<template>
  <div class="receive-nft-comp send-nft-confirm-comp">
    <div class="nft-card-row">
      <nft-card-comp v-if="info" :data="cardInfo" :flip-lock="true" />
    </div>
    <div class="content-area">
      <div class="text-box">
        <div class="profile-row">
          <img :src="getProfileSrc(info.sender.profileImg)" />
        </div>
        <div>
          <p class="text">
            <span>{{
                $t('receiveNtfc.nftReceive.text', {
                  sender: info.sender.name,
                  name: `${ info.cltnName } ${info.name}`,
                  type: $t(`nftType.${info.cltnType}`),
                })
              }}</span
            ><br />
          </p>
        </div>
      </div>
      <div class="button-row">
        <mv-button type="round-black" text="common.ok" @click="$emit('ok')" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent} from 'vue';
import MvButton from '@/components/common/button/MvButton.vue';
import NftCardComp from '@/components/common/card/NftCardComp.vue';
import { getProfileSrc } from '@/script/profile/profileImageScript';

export default defineComponent({
  name: 'SendNftConfirmComp.vue',
  emits: ['ok'],
  props: {
    info: {
      default: {
        id: 0,
        type: '',
        cltnType: '',
        color: '',
        logoImg: '',
        image: '',
        brandName: '',
        brandProfile: '',
        name: '',
        cltnName: '',
        nftType: '',
        sender: {
          id: 0,
          name: '',
          profileImg: '',
        },
      },
    },
  },
  components: {
    MvButton,
    NftCardComp,
  },
  setup(props) {
    const cardInfo = computed(() => {
      return {
        ...props.info,
        type: props.info.nftType
      }
    })
    return {
      getProfileSrc,
      cardInfo,
    };
  },
});
</script>
